export const FILTER_COLLECTION_ADD = 'FILTER_COLLECTION_ADD';
export const FILTER_COLLECTION_REMOVE = 'FILTER_COLLECTION_REMOVE';
export const FILTER_COLLECTION_SET = 'FILTER_COLLECTION_SET';
export const FILTER_COLLECTION_CLEAR = 'FILTER_COLLECTION_SET';
